import axios from "axios";
import {
    ADD_NEW_USER_CERT,
    DELETE_USER_CERT,
    UPDATE_USER_CERT,
} from "./RestCatalog";


const addNewUserCert = (payload) => {
    return axios.post(ADD_NEW_USER_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUserCert = (payload) => {
    return axios.post(DELETE_USER_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUserCert = (payload) => {
    return axios.post(UPDATE_USER_CERT, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { addNewUserCert, deleteUserCert, updateUserCert };

